<template>
  <el-dialog title="内部邮件" :visible.sync="dialogFormVisible" custom-class="max-dialog1256" center :append-to-body="true"
             :close-on-click-modal="false" @close="closeDialog"
  >
    <el-form :model="form" ref="form1">
      <div id="_Container_0" style="width: 1256px; height: 584px;display: contents;">

        <div id="exchange_main">
          <div id="exchange_left">
            <div class="OP">
              <input v-model="searchdata" placeholder="请输入关键字"
                     Style="height: 26px;line-height: 26px; width: 300px;margin-left:5px;"/>
              <!--<el-input v-model="searchdata"  placeholder="请输入关键字" Style="width: 300px;margin-left:5px;" auto-complete="off"></el-input>-->
              <img src="/static/img/1px.png" @click="bindExchangeList('')" @error="imgError" id="btnSearch"/>
            </div>
            <div class="exchange_left_title">
              <a id="All" href="#" @click="bindExchangeList('All')">全部</a><span>|</span><a id="UnRead" href="#"
                                                                                           @click="bindExchangeList('UnRead')">未读</a><span>|</span><a
              id="Important"
              href="#" @click="bindExchangeList('IsImportant')">重要</a><span>|</span><a
              id="Hide" @click="bindExchangeList('Hide')" href="#">隐藏</a>
            </div>
            <div class="exchange_split"></div>
            <div class="exchange_left_content">
              <ul class="GridStyle" style="width: 100%;">
                <li class="RowStyle" v-for="(exchange,index) in exchangeData" v-on:mouseover="Showicon(true,exchange)"
                    v-on:mouseout="Showicon(false,exchange)">
                  <a :title="exchange.extitle"
                     @click="leftClick(exchange.unitguid, exchange.exstatus, exchange.exchangeguid,exchange.feedbacktimes)"
                     style="float: left;cursor: pointer">{{(exchange.extitle || "").substr(0, 10)}}</a>
                  <span style="float: left">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  <span class="ui-icon-small ui-icon-small-delete" style="float: left;"
                        @click="updateisdel(index,exchange.unitguid,exchange.isdel)"
                        v-show="exchange.visible && type!='Hide'" title="转移到隐藏区域！"></span>
                  <span class="ui-icon-small ui-icon-small-undo" style="float: left;" title="还原！"
                        @click="updateisdel(index,exchange.unitguid,exchange.isdel)"
                        v-show="exchange.visible && type=='Hide'"></span>
                  <span :class="exchange.isimportant==100? 'Important star_gray':'Important star'"
                        @click="updateIsImportant(index,exchange.unitguid,exchange.isimportant)"
                        style="padding-left: 5px"></span>
                  <span class="ui-icon-redmessage" v-show="(exchange.feedbacktimes||0)>0">&nbsp;{{exchange.feedbacktimes}}</span>
                  <br>
                  <span class="dispName"
                        style="float: right; padding-right: 20px">{{exchange.senduname || ""}} {{(exchange.senddate || "").substr(0, 10)}}</span>
                </li>
              </ul>
              <div class="foot">
                <Pagination ref="pagination1" @bindgrid="bindExchangeList" :pagination="pagination"></Pagination>
              </div>

            </div>
          </div>
          <div class="exchange_right">
            <div class="exchange_right_title" id="ExTitle">{{extitle || ""}}
            </div>
            <div class="exchange_right_extra" style="padding-left: 5px;">
              <span id="PersonsList" title=""
                    style="float: left; margin: auto 0px;white-space: nowrap; text-overflow: ellipsis; overflow: hidden;width:580px"
                    :title="receiveunames">人员：{{receiveunames || ""}}</span>
              <!--<span id="PersonsList" title="" style="float: left; margin: auto 0px;"></span>-->
              <a id="SignInfor" style="display: inline-flex;cursor: pointer" @click="showExchangeList()"><img
                style="width: 24px;height: 24px;"
                src="/static/img/sign.png" @error="imgError"/>签收情况</a>
              <ExchangeList ref="ExchangeList"></ExchangeList>
              <AppendUser ref="AppendUser" @getRightDetail="getRightDetail"></AppendUser>
              <a id="AddPersons" style="display: inline-flex;cursor: pointer" @click="appendUser"><img style="width: 24px;height: 24px;"
                                                                                       src="/static/img/add.png"
                                                                                       @error="imgError"/>追加人员</a>
            </div>
            <div id="exchange_content" ref="content" v-on:scroll="handleScroll"
                 style="width: 100%;  height:  calc(96vh - 149px); overflow-y: scroll;">
              <ul style="width: 100%;">
                <li v-for="(feedBack,index) in feedBackData">
                  <div class="exchange_right_content">
                    <img class="exchange_right_content_sub_img ImgCircular60" style="border-radius: 50%;"
                         :src="PhotoPre+feedBack.uguid+'/p.png'" onerror="this.src='/static/img/icon/tx_icon1.png'">

                    <div class="exchange_right_content_sub_con"><span
                      class="exchange_right_content_sub_name">{{feedBack.uname || ""}}</span><span style="float: right;"
                                                                                                   class="exchange_right_content_sub_time">{{index + 1}}# &nbsp;{{feedBack.adddate || ""}}</span>
                    </div>

                    <div class="exchange_right_content_sub_con" style="min-height: 40px;" v-html="feedBack.feedcontent">
                    </div>

                    <div class="exchange_right_content_sub_con"
                         v-if="feedBack.uguid==uguid && index + 1 == contentcount&&new Date().setMinutes(new Date().getMinutes()-30)<new Date(feedBack.adddate)">
                      <a class="ExchangeDel"
                         @click="DelFeedBack(feedBack.unitguid,feedBack.relationguid,feedBack.adddate)">删除</a></div>
                    <div>

                      <CommonUpload :multiple="true" :groupGuid="feedBack.attguid" :disabled="true"
                                    groupType="exchange" :limit="10"></CommonUpload>
                    </div>
                    <div class="exchange_right_content_sub_con"></div>
                  </div>
                </li>
              </ul>
            </div>

            <div id="UEContainer" class="exchange_right_reply" v-show="ifReply">
              <div class="divEditContent" id="divEditContent" style="">
                <div>
                  <QuillEditor ref="refdiscripDetail" toolbarid="exchangedetailtoolbar" :content="form.feedcontent"
                               @on-content-change="changeDiscrip"></QuillEditor>
                </div>
                <div style="padding-top: 10px;">
                  <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attguid" :disabled="!CanEdit"  @afterBind="afterBind"
                                groupType="exchange" :limit="10"></CommonUpload>
                </div>
                <div slot="footer" style="text-align: center;" class="dialog-footer">

                  <el-button @click="ifReply = false">取 消</el-button>
                  <el-button type="primary" @click="saveFeedBackData" :disabled="isDisable">回 复</el-button>
                </div>

              </div>


            </div>
            <div class="exchange_Showreply" v-show="!ifReply" @click="showReply()"></div>

            <span id="scrolltop" v-show="goTopShow" class="scrollTop" @click="GoToTop()"
                  style="left: 1272px;">回顶部</span>
            <span id="scrollbottom" v-show="goToBottom" @click="GoToBottom()" style="left: 1272px;">到底部</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hide()">关 闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import {
    getExchangeListData,
    getDetail,
    saveData,
    updateData,
    saveFeedBackData,
    DeleteFeedBackInfo
  } from '@/api/oa/exchange';
  import QuillEditor from '../../common/QuillEditor';
  import {attUUID} from '@/api/attachment';
  import ExchangeList from './ExchangeList';
  import AppendUser from './AppendUser'

  export default {
    name: 'ExchangeDetail',
    data() {
      return {
        height: 0,
        goTopShow: false,
        goToBottom: false,
        scroll: 0,
        uguid: '',
        PhotoPre: '',
        type: 'All',
        isdel: '',
        isdelete: false,
        isreduction: false,
        contentcount: 0,
        isDisable: false,
        dialogFormVisible: false,
        ifReply: false,
        searchdata: '',
        exchangeData: [],
        exchangeguid: '',
        unitguid: '',
        extitle: '',
        exstatus: 0,
        receiveunames: '',
        receiveuguids: '',
        feedBackData: [],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },

        CanEdit: true,
        nofile: false,
        form: {
          attguid: '',
          feedcontent: '',
          relationguid: ''
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          feedcontent: [
            {required: true, message: '请输入内容', trigger: 'blur'},
          ]
        },

      }
    },
    methods: {
      //获取最大高度
      getHeight() {
        var clientHeight = this.$refs.content.clientHeight;
        var scrollHeight = this.$refs.content.scrollHeight;
        this.height = scrollHeight - clientHeight; //超出窗口上界的值就是底部的scrolTop的值
      },

      //监控scroll
      handleScroll() {
        if(this.height==0)
          this.getHeight();
        this.scroll = this.$refs.content.scrollTop
        //回到顶部是否显示
        if (this.scroll > 0) {
          this.goTopShow = true;
        }
        else
          this.goTopShow = false;
          //回到底部是否显示
        if (this.scroll < this.height) {
          this.goToBottom = true;
        }
        else {
          this.goToBottom = false;
        }
      },
      //回到顶部
      GoToTop() {
        this.$refs.content.scrollTop = 0;
      },
      //回到底部
      GoToBottom() {
        this.$refs.content.scrollTop = this.height;
      },
      //上传附件后调用
      afterBind(fileList){
        var addHeight = 30*fileList.length;
        var divEditContent=document.querySelector("#divEditContent");
        divEditContent.style.height= 420 +addHeight+"px";
      },
      //删除回复
      DelFeedBack(unitguid, adddate) {
        var now = new Date().setMinutes(new Date().getMinutes() - 30);
        if (now > new Date(adddate)) {
          this.$message({
            type: 'error',
            message: "回复时间超出30分钟"
          });
          getRightDetail(this.exchangeguid);
        }
        else {
          this.$confirm('是否确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            DeleteFeedBackInfo({unitguid: unitguid}).then(response => {
              if (response.data.code === 0) {
                //更新exchange表的未读-1,未读-1后更新状态，更新回复人的反馈时间
                updateData({
                  exchangeguid: this.exchangeguid,
                  addfeedbacktimes: -1,
                  unitguid: this.unitguid
                }).then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                  } else {
                  }
                });

              } else {
                this.$message({
                  type: 'error',
                  message: response.data.msg
                });
              }
              //刷新列表
              this.getRightDetail(this.exchangeguid);
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      closeDialog() {
        this.$emit("bindExchangeList", 7);
      },
      //控制删除还原等小图标的显示
      Showicon(ifShow, row) {
        row.visible = ifShow;
      },
      //修改交流协作的状态（删除、正常）
      updateisdel(index, unitguid, isdel) {
        if (isdel == 0)
          isdel = 1;
        else
          isdel = 0;
        var data = {unitguid: unitguid, isdel: isdel};
        saveData(data).then(response => {
          if (response.data.code == 0) {
            this.exchangeData.splice(index, 1);
          } else {
          }
        });

      },
      //追加人员
      appendUser() {
        this.$refs.AppendUser.show(this.extitle, this.exchangeguid, this.contentcount, this.receiveuguids);

      },
      //更新是否重要
      updateIsImportant(index, unitguid, isimportant) {
        if (isimportant == 100) {
          isimportant = 200;
        }
        else {
          isimportant = 100;
        }
        var data = {unitguid: unitguid, isimportant: isimportant}
        saveData(data).then(response => {
          if (response.data.code == 0) {
            this.exchangeData[index].isimportant = isimportant;
          } else {
          }
        });

      },
      //绑定人员
      bindReceivedName(receiveunames) {
        this.receiveunames = this.receiveunames + ',' + receiveunames;
      },
      //签收情况
      showExchangeList() {
        this.$refs.ExchangeList.show(this.exchangeguid);
      },
      //签收后再绑定左侧列表
      updateTimes(unitguid, exstatus, type) {
        this.unitguid = unitguid;
        if (type != null && type != "")
          this.type = type;
        this.exstatus = exstatus;
        var data = {unitguid: unitguid, feedbacktimes: 0, exstatus: 300, sign: 1};
        saveData(data).then(response => {
          if (response.data.code == 0) {
            this.bindExchangeList(this.type);
          } else {
          }
        });
      },
      //控制回复框的显示
      showReply() {
        this.ifReply = !this.ifReply;
        this.form.attguid = attUUID();
        //设置输入框的高度
        var list=document.querySelectorAll(".ql-container");
        for(var i=0;i<list.length;i++)
        {
          list[i].style.height="200px";
        }
      },
      //新增一条
      saveFeedBackData() {
        if (this.form.feedcontent == "") {
          this.$message({
            type: 'error',
            message: '请输入回复内容！'
          });
          return;
        }
        this.isDisable = true;
        this.form.relationguid = this.exchangeguid;
        //新增回复
        saveFeedBackData(this.form).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '回复成功',
              type: 'success'
            })
            //更新exchange表的未读+1
            updateData({
              exchangeguid: this.exchangeguid,
              addfeedbacktimes: 1,
              unitguid: this.unitguid
            }).then(response => {
              if (response.data.code == 0) {
                this.bindExchangeList(this.type);
              } else {
              }
            });
            this.form.feedcontent = '';
            //刷新列表
            this.getRightDetail(this.exchangeguid);
            this.ifReply = false;
          } else {
            this.$message.error(response.data.msg);
          }
          //
          this.isDisable = false;
        });
      },
      //给feedcontent赋值
      changeDiscrip(val) {
        this.form.feedcontent = val;
      },
      //首次加载左右侧列表
      bindfirstExchangeList(type, exchangeguid, unitguid, exstatus, feedbacktimes) {
        if (type != null && type != "")
          this.type = type;//初始为All
        if (unitguid != null && unitguid != "") {
          this.unitguid = unitguid;
          this.exchangeguid = exchangeguid;
          //先更新再获取列表
          if (feedbacktimes > 0)
            this.updateTimes(unitguid, exstatus, type);
          else
            this.bindExchangeList(this.type);
          //加载右侧列表
          this.getRightDetail(this.exchangeguid);
        }
        //先获取左侧第一条数据再根据第一条数据加载左侧右侧数据
        else {
          var data = {
            offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
            limit: this.pagination.pageSize,
            isdel: 0,
            searchdata: this.searchdata
          };
          if (this.type == "UnRead")
            data.exstatu = 300;
          else if (this.type == "IsImportant") {
            data.isimportant = 200;
          }
          else if (this.type == "Hide")
            data.isdel = 1;
          getExchangeListData(data).then(response => {
            this.exchangeguid = response.data.obj.rows[0].exchangeguid;
            this.unitguid = response.data.obj.rows[0].unitguid;
            this.exstatus = response.data.obj.rows[0].exstatus;
            if (response.data.obj.rows[0].feedbacktimes > 0)
              this.updateTimes(this.unitguid, this.exstatus, this.type);
            else
              this.bindExchangeList(this.type);
            //加载右侧列表
            this.getRightDetail(this.exchangeguid);
          }).catch((error) => {

          });
        }

      },

      //绑定左侧列表
      bindExchangeList(type) {
        if (type != null && type != "")
          this.type = type;
        var data = {
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          isdel: 0,
          searchdata: this.searchdata
        };
        if (this.type == "UnRead")
          data.exstatu = 300;
        else if (this.type == "IsImportant") {
          data.isimportant = 200;
        }
        else if (this.type == "Hide")
          data.isdel = 1;
        getExchangeListData(data).then(response => {
          this.pagination.total = response.data.obj.total;
          this.exchangeData = response.data.obj.rows;
          this.exchangeData.forEach((item, index) => {
            this.$set(item, "visible", false)
          });
        }).catch((error) => {

        });
      },
      //绑定右侧数据
      getRightDetail(exchangeguid) {
        getDetail({exchangeguid: exchangeguid}).then(response => {
          this.exchangeguid = exchangeguid;
          this.extitle = response.data.obj.extitle;
          this.receiveunames = response.data.obj.receiveunames;
          this.receiveuguids = response.data.obj.receiveuguids;
          this.contentcount = response.data.feedBack.length;
          this.feedBackData = response.data.feedBack;
          //更新回到顶部回到底部
          setTimeout(() => {
            this.getHeight();
            this.handleScroll();
          }, 500);

        });
      },
      //左侧点击
      leftClick(unitguid, exstatus, exchangeguid, feedbacktimes) {
        this.unitguid = unitguid;
        if (feedbacktimes > 0)
          this.updateTimes(unitguid, exstatus, '');//签收再绑定左侧
        this.getRightDetail(exchangeguid);//绑定右侧数据
      },
      show(exchangeguid, unitguid, exstatus, feedbacktimes) {
        this.ifReply = false;
        this.searchdata = '';
        this.bindfirstExchangeList('All', exchangeguid, unitguid, exstatus, feedbacktimes);
        this.dialogFormVisible = true
      },
      hide() {
        //刷新列表
        this.$emit('bindExchangeList');
        this.dialogFormVisible = false;

      }

    },
    mounted() {
      //个人信息
      var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      //多企业信息
      var tokenInfo = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
      this.PhotoPre = tokenInfo.attviewpath + "/" + userinfo.tenantid + "/myphoto/";
      this.uguid = userinfo.uguid;
    },
    components: {
      QuillEditor,
      ExchangeList,
      AppendUser
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @import "../../../../static/css/exchangemain.css";


</style>



// WEBPACK FOOTER //
// src/components/oa/exchange/ExchangeDetail.vue